import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ServiceModel } from '../../models/configuration/company/service.model';
import { ConfigurationRepository } from '../../repositories/configuration.repository';

export class GetServiceByCompanyidUseCase
  implements UseCase<void, ServiceModel>
{
  constructor(private configurationRepository: ConfigurationRepository) {}

  execute(): Observable<ServiceModel> {
    return this.configurationRepository.getServiceByCompanyid();
  }
}